<template>
  <div>
    <c-box
      :loading="loading"
      shadow
    >
      <div class="row">
        <template v-if="!loading && dataAge.length">
          <div class="col-md-7">
            <metrics-table :data="dataAge.map(i => ({name: i.Возраст, visits: i.Визиты}))" />
          </div>
          <div class="col-md-5">
            <c-doughnut-chart
              class="doughnut-chart"
              :chart-data="chartData"
              :options="chartOptions"
            />
          </div>
        </template>
        <div
          v-if="!loading && !dataAge.length"
          class="col-md-12"
        >
          <no-data />
        </div>
      </div>
      <div
        class="row text-center text-bold margin-top"
      >
        <template v-if="!loading && dataGender.length">
          <div class="col-md-6">
            Мужчины {{ dataGender.find(i => i.Пол === 'Мужчины').Визиты }}
          </div>
          <div class="col-md-6">
            Женщины {{ dataGender.find(i => i.Пол === 'Женщины').Визиты }}
          </div>
        </template>
        <div
          v-if="!loading && !dataGender.length"
          class="col-md-12"
        >
          <no-data />
        </div>
      </div>
    </c-box>

    <p
      v-if="conclusion"
      v-html="conclusionHtml"
    />
  </div>
</template>

<script>
import CBox from '../../../../../../../resources/js/components/ui/CBox.vue'
import { conclusion1CToHtml } from '../../../../../../../resources/js/helper'
import NoData from '../../../../../../../resources/js/components/NoData.vue'
import moment from 'moment'
import CDoughnutChart from '../../../../../../../resources/js/components/ui/CDoughnutChart.vue'
import diagramColors from '../../../../../../../resources/js/mixins/diagramColors'
import MetricsTable from '../../../../../../../resources/js/components/MetricsTable.vue'

export default {
  name: 'TrafficDemographics',
  components: { MetricsTable, CDoughnutChart, NoData, CBox },
  mixins: [diagramColors],
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    dataAge: {
      type: Array,
      required: true
    },
    dataGender: {
      type: Array,
      required: true
    },
    conclusion: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      chartOptions: {
        legend: {
          display: false
        },
        animation: {
          animateScale: true,
          animateRotate: true
        },
        plugins: {
          datalabels: {
            display: false
          }
        }
      }
    }
  },
  computed: {
    date () {
      return moment().month(this.month)
    },
    chartData () {
      return {
        labels: this.dataAge.map(i => i.Возраст),
        datasets: [
          {
            data: this.dataAge.map(i => i.Визиты),
            backgroundColor: this.dataAge.map((item, index) => this.getNextDiagramColor(index))
          }
        ]
      }
    },
    conclusionHtml () {
      return conclusion1CToHtml(this.conclusion)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

.doughnut-chart {
  @media (max-width: $smBreakpoint) {
    width: 50%;
    margin: 0 auto 20px auto;
  }

  @media (max-width: $xsBreakpoint) {
    width: 100%;
  }
}
</style>
